import { AlertResponse } from '@eagle/core-data-types';

export interface AlertHistoryReferenceData {
  occurred: Date;
  type: 'alert';
  typeId: string;
}

export const buildAlertHistoryReferenceData = (alert: AlertResponse): AlertHistoryReferenceData => ({
  occurred: alert.occurred,
  type: 'alert',
  typeId: alert.alertTypeId,
});
